/**
 * Site configuration helper
 * Returns the current site URL based on runtime domain
 * Supports multiple domains: huongnghiep.cat.edu.vn, thpt.thitrenmaytinh.edu.vn
 */

const CANONICAL_DOMAIN = 'https://huongnghiep.cat.edu.vn';

export function getSiteUrl(): string {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return CANONICAL_DOMAIN;
}

export function getCanonicalUrl(path: string = '/'): string {
  const base = getSiteUrl();
  return `${base}${path}`;
}

export const SITE_NAME = 'Thi trên máy tính THPT | Thi thử TN THPT | ĐGNL bản quyền IEQTE';
export const SITE_PROVIDER = 'Viện Khảo thí và Đánh giá Chất lượng Giáo dục';
export const SITE_BRAND = 'Thi trên máy tính THPT';
